import NewsArticle from './NewsArticle';

export default class NewsConfiguration
{
    public importantUpdateText: string = '';
    public continueToSiteText: string = '';
    public previousUpdateText: string = '';
    public nextUpdateText: string = '';
    public imageUrl: string = '';
    public articles: NewsArticle[] = [];
}